import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {useInterval} from 'react-use';
import { shape, string, number } from 'prop-types';

import { checkoutActions } from '../../../store/actions';
import { getTime, formatAmount } from '../../../utils';

import Button from '../../Button';

import s from './index.module.css';

const getRemainingTime = (valid) => {
  const currentDate = new Date();
  const diffSeconds = parseInt((valid - currentDate) / 1000);

  if(diffSeconds <= 0) {
    return null;
  }

  return getTime(diffSeconds);
}

const PaymentMessage = ({ authOptions, valid, amount }) => {
  const dispatch = useDispatch();
  const currentDate = new Date();
  const defaultTime = getRemainingTime(valid);
  const defaultIsActive = valid - currentDate > 0;
  const [remainingTime, setRemainingTime] = useState(defaultTime);
  const [isActive, setIsActive] = useState(defaultIsActive);

  const onClickHandler = () => {
    dispatch(checkoutActions.pay(authOptions));
  };

  useInterval(
    () => {
      const time = getRemainingTime(valid);

      if(!time) {
        setIsActive(false);
        return;
      }

      setRemainingTime(time);
    },
    isActive ? 1000 : null
  );

  return (
    <div className={s.wrapper}>
      <Button
        disabled={!isActive}
        className={s.paymentButton}
        onClick={onClickHandler}
        >
          Оплатить {formatAmount(amount)} ₽
      </Button>
      {isActive && <div className={s.remainingTime}>Осталось {remainingTime}</div>}
    </div>
  );
};

PaymentMessage.propTypes = {
  amount: number,
  valid: number,
  authOptions: shape({
    publicId: string,
    description: string,
    amount: number,
    currency: string,
    invoiceId: string,
    accountId: string,
  }),
};

PaymentMessage.defaultProps = {
  order: {
    items: [],
  }
};

export default PaymentMessage;
